import React from "react";
import CCGatewayProvider from "../../providers/CreditCardGatewayProvider"
import GatewayConfiguration from "../../components/Gateway/GatewayConfiguration"

const AddEditGateway = () => {
  return <CCGatewayProvider><GatewayConfiguration /></CCGatewayProvider>;
};

export default AddEditGateway;
